import type { ReviewDistRow } from "../../../types/reviews";

const STAR_COLOR: Record<number, string> = {
  5: "var(--rv-good)",
  4: "var(--rv-good-light)",
  3: "var(--rv-neutral)",
  2: "var(--rv-warn-light)",
  1: "var(--rv-bad)",
};

export function RatingDist({ dist }: { dist: ReviewDistRow[] }) {
  const total = dist.reduce((s, r) => s + r.count, 0) || 1;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {dist.map((row) => (
        <div className="rv-dist-row" key={row.star}>
          <span>★{row.star}</span>
          <div className="rv-dist-track">
            <div className="rv-dist-bar" style={{ width: `${(row.count / total) * 100}%`, background: STAR_COLOR[row.star] }} />
          </div>
          <span className="rv-dist-count">
            {row.count}件・{Math.round((row.count / total) * 100)}%
          </span>
        </div>
      ))}
    </div>
  );
}
